export const apiEndpoints = {
  baseUrl: 'https://apishowcasen.smarterchains.com',
  assessmentMaturity: '/assessmentmaturity',
  testUrl : 'http://185.19.30.43/educateprepare/api'
}